import { GenericService } from './details.model';

export class KioskSvc extends GenericService {}

// TODO combine with kiosks.model.ts
